// Code generated by domaingen. DO NOT EDIT.

/* eslint-disable dot-notation */

import type Enums from './Enums';

export type UnitEnumValue = (typeof Enums.Unit)[keyof typeof Enums.Unit];

export type CategoryDefinition = {
  label: string;
};

export type UnitDefinition = {
  value: UnitEnumValue;
  label: string;
  description: string;
  category: CategoryDefinition;
  conversionFactor: number | null;
};

export const CategoryKeys = [
  'Dry Volume',
  'Wet Volume',
  'Length',
  'Area',
  'Weight',
  'Pressure',
  'Other',
] as const;

export const Categories: Record<(typeof CategoryKeys)[number], CategoryDefinition> = {
  'Dry Volume': {
    label: 'Dry Volume',
  },
  'Wet Volume': {
    label: 'Wet Volume',
  },
  Length: {
    label: 'Length',
  },
  Area: {
    label: 'Area',
  },
  Weight: {
    label: 'Weight',
  },
  Pressure: {
    label: 'Pressure',
  },
  Other: {
    label: 'Other',
  },
};

export const Units: Record<UnitEnumValue, UnitDefinition> = {
  cu_yd: {
    value: 'cu_yd' as Enums.Unit,
    label: 'CUYD',
    description: 'cubic yards',
    category: Categories['Dry Volume'],
    conversionFactor: 46656,
  },

  ea: {
    value: 'ea' as Enums.Unit,
    label: 'EA',
    description: 'each',
    category: Categories['Other'],
    conversionFactor: null,
  },

  lb: {
    value: 'lb' as Enums.Unit,
    label: 'LB',
    description: 'pounds',
    category: Categories['Weight'],
    conversionFactor: 16,
  },

  tn: {
    value: 'tn' as Enums.Unit,
    label: 'TN',
    description: 'short tons',
    category: Categories['Weight'],
    conversionFactor: 32000,
  },

  fl_oz: {
    value: 'fl_oz' as Enums.Unit,
    label: 'FL OZ',
    description: 'fluid ounces',
    category: Categories['Wet Volume'],
    conversionFactor: 1,
  },

  fl_oz_per_cwt: {
    value: 'fl_oz_per_cwt' as Enums.Unit,
    label: 'FL OZ/CWT',
    description: 'fl oz per hundredweight',
    category: Categories['Wet Volume'],
    conversionFactor: 1,
  },

  gal: {
    value: 'gal' as Enums.Unit,
    label: 'GAL',
    description: 'gallons',
    category: Categories['Wet Volume'],
    conversionFactor: 128,
  },

  per_hr: {
    value: 'per_hr' as Enums.Unit,
    label: 'HR',
    description: 'per hour',
    category: Categories['Other'],
    conversionFactor: null,
  },

  in: {
    value: 'in' as Enums.Unit,
    label: 'IN',
    description: 'inches',
    category: Categories['Length'],
    conversionFactor: 1,
  },

  ft: {
    value: 'ft' as Enums.Unit,
    label: 'FT',
    description: 'feet',
    category: Categories['Length'],
    conversionFactor: 12,
  },

  yd: {
    value: 'yd' as Enums.Unit,
    label: 'YD',
    description: 'yards',
    category: Categories['Length'],
    conversionFactor: 36,
  },

  lf: {
    value: 'lf' as Enums.Unit,
    label: 'LF',
    description: 'linear feet',
    category: Categories['Length'],
    conversionFactor: 12,
  },

  mm: {
    value: 'mm' as Enums.Unit,
    label: 'mm',
    description: 'millimeters',
    category: Categories['Length'],
    conversionFactor: 0.03937007874,
  },

  cm: {
    value: 'cm' as Enums.Unit,
    label: 'cm',
    description: 'centimeters',
    category: Categories['Length'],
    conversionFactor: 0.3937007874,
  },

  m: {
    value: 'm' as Enums.Unit,
    label: 'm',
    description: 'meters',
    category: Categories['Length'],
    conversionFactor: 39.37007874,
  },

  km: {
    value: 'km' as Enums.Unit,
    label: 'km',
    description: 'kilometers',
    category: Categories['Length'],
    conversionFactor: 39370.07874,
  },

  mi: {
    value: 'mi' as Enums.Unit,
    label: 'MI',
    description: 'miles',
    category: Categories['Length'],
    conversionFactor: 63360,
  },

  sq_in: {
    value: 'sq_in' as Enums.Unit,
    label: 'SQ IN',
    description: 'square inches',
    category: Categories['Area'],
    conversionFactor: 1,
  },

  sq_ft: {
    value: 'sq_ft' as Enums.Unit,
    label: 'SQ FT',
    description: 'square feet',
    category: Categories['Area'],
    conversionFactor: 144,
  },

  sq_yd: {
    value: 'sq_yd' as Enums.Unit,
    label: 'SQ YD',
    description: 'square yards',
    category: Categories['Area'],
    conversionFactor: 1296,
  },

  sq_mi: {
    value: 'sq_mi' as Enums.Unit,
    label: 'SQ MI',
    description: 'square miles',
    category: Categories['Area'],
    conversionFactor: 4014489600,
  },

  ac: {
    value: 'ac' as Enums.Unit,
    label: 'AC',
    description: 'acres',
    category: Categories['Area'],
    conversionFactor: 6272640,
  },

  sq_mm: {
    value: 'sq_mm' as Enums.Unit,
    label: 'sq mm',
    description: 'square millimeter',
    category: Categories['Area'],
    conversionFactor: 0.0015500031,
  },

  sq_cm: {
    value: 'sq_cm' as Enums.Unit,
    label: 'sq cm',
    description: 'square centimeter',
    category: Categories['Area'],
    conversionFactor: 0.15500031,
  },

  sq_m: {
    value: 'sq_m' as Enums.Unit,
    label: 'sq m',
    description: 'square meters',
    category: Categories['Area'],
    conversionFactor: 1550.0031,
  },

  sq_km: {
    value: 'sq_km' as Enums.Unit,
    label: 'sq km',
    description: 'square kilometers',
    category: Categories['Area'],
    conversionFactor: 1550003100,
  },

  cu_in: {
    value: 'cu_in' as Enums.Unit,
    label: 'CUIN',
    description: 'cubic inches',
    category: Categories['Dry Volume'],
    conversionFactor: 1,
  },

  cu_ft: {
    value: 'cu_ft' as Enums.Unit,
    label: 'CUFT',
    description: 'cubic feet',
    category: Categories['Dry Volume'],
    conversionFactor: 1728,
  },

  cu_mm: {
    value: 'cu_mm' as Enums.Unit,
    label: 'mm³',
    description: 'cubic millimeters',
    category: Categories['Dry Volume'],
    conversionFactor: 0.0000610237441,
  },

  cu_cm: {
    value: 'cu_cm' as Enums.Unit,
    label: 'cm³',
    description: 'cubic centimeters',
    category: Categories['Dry Volume'],
    conversionFactor: 0.0610237441,
  },

  cu_m: {
    value: 'cu_m' as Enums.Unit,
    label: 'm³',
    description: 'cubic meters',
    category: Categories['Dry Volume'],
    conversionFactor: 61023.7441,
  },

  pt: {
    value: 'pt' as Enums.Unit,
    label: 'PT',
    description: 'pints',
    category: Categories['Wet Volume'],
    conversionFactor: 16,
  },

  qt: {
    value: 'qt' as Enums.Unit,
    label: 'QT',
    description: 'quarts',
    category: Categories['Wet Volume'],
    conversionFactor: 32,
  },

  L: {
    value: 'L' as Enums.Unit,
    label: 'L',
    description: 'liters',
    category: Categories['Wet Volume'],
    conversionFactor: 33.8140227018,
  },

  mL: {
    value: 'mL' as Enums.Unit,
    label: 'mL',
    description: 'milliliters',
    category: Categories['Wet Volume'],
    conversionFactor: 0.0338140227018,
  },

  oz: {
    value: 'oz' as Enums.Unit,
    label: 'OZ',
    description: 'ounces',
    category: Categories['Weight'],
    conversionFactor: 1,
  },

  g: {
    value: 'g' as Enums.Unit,
    label: 'g',
    description: 'grams',
    category: Categories['Weight'],
    conversionFactor: 0.0352739619,
  },

  kg: {
    value: 'kg' as Enums.Unit,
    label: 'kg',
    description: 'kilograms',
    category: Categories['Weight'],
    conversionFactor: 35.2739619,
  },

  t: {
    value: 't' as Enums.Unit,
    label: 'tonne',
    description: 'metric tons',
    category: Categories['Weight'],
    conversionFactor: 35273.9619,
  },

  per_L: {
    value: 'per_L' as Enums.Unit,
    label: 'L',
    description: 'per liter',
    category: Categories['Wet Volume'],
    conversionFactor: 33.8140227018,
  },

  per_qty: {
    value: 'per_qty' as Enums.Unit,
    label: 'QTY',
    description: 'per quantity',
    category: Categories['Other'],
    conversionFactor: null,
  },

  per_cu_yd: {
    value: 'per_cu_yd' as Enums.Unit,
    label: 'CUYD',
    description: 'per cubic yard',
    category: Categories['Dry Volume'],
    conversionFactor: 46656,
  },

  per_m: {
    value: 'per_m' as Enums.Unit,
    label: 'm',
    description: 'per meter',
    category: Categories['Length'],
    conversionFactor: 39.37007874,
  },

  bag: {
    value: 'bag' as Enums.Unit,
    label: 'BAG',
    description: 'bag',
    category: Categories['Other'],
    conversionFactor: null,
  },

  dosage: {
    value: 'dosage' as Enums.Unit,
    label: 'DOSAGE',
    description: 'dosage',
    category: Categories['Other'],
    conversionFactor: null,
  },

  percent: {
    value: 'percent' as Enums.Unit,
    label: '%',
    description: 'percent',
    category: Categories['Other'],
    conversionFactor: null,
  },

  per_tn: {
    value: 'per_tn' as Enums.Unit,
    label: 'TN',
    description: 'per short ton',
    category: Categories['Weight'],
    conversionFactor: 32000,
  },

  per_load: {
    value: 'per_load' as Enums.Unit,
    label: 'LOAD',
    description: 'per load',
    category: Categories['Other'],
    conversionFactor: null,
  },

  per_half_load: {
    value: 'per_half_load' as Enums.Unit,
    label: 'HALF LOAD',
    description: 'per half load',
    category: Categories['Other'],
    conversionFactor: null,
  },

  per_cu_m: {
    value: 'per_cu_m' as Enums.Unit,
    label: 'm³',
    description: 'per cubic meter',
    category: Categories['Dry Volume'],
    conversionFactor: 61023.7441,
  },

  block_equivalent_unit: {
    value: 'block_equivalent_unit' as Enums.Unit,
    label: 'BEU',
    description: 'Block Equivalent Units',
    category: Categories['Other'],
    conversionFactor: 1,
  },

  psi: {
    value: 'psi' as Enums.Unit,
    label: 'PSI',
    description: 'pounds per square inch',
    category: Categories['Pressure'],
    conversionFactor: 1,
  },

  mpa: {
    value: 'mpa' as Enums.Unit,
    label: 'MPa',
    description: 'megapascals',
    category: Categories['Pressure'],
    conversionFactor: 145.03773773,
  },
};
